export default "__VITE_ASSET__DRMW8a8$__"